import { jsx as _jsx } from "react/jsx-runtime";
const SvgComponent = () => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M21 10H3M21 6H3M21 14H3M21 18H3" }) }));
export default SvgComponent;
